module.exports = new __parcel__URL__("c1s10.e7c394d6.jpg").toString();